import { Exception } from './exception';

/**
 * Exception thrown when something can not be used in its current state.
 */
export class NotUsableException extends Exception {}
